// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2866bc57","113":"5b59fe92","810":"465a4117"}[chunkId] + ".chunk.js";
};